/**
 * @generated SignedSource<<b3c8e4e3a7f58562f48173a0657e73ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BookingType = "DINING" | "LESSON" | "STANDARD";
export type RecurringRequestExclusionReason = "AGENDA_UNAVAILABLE" | "REQUEST_NOT_AVAILABLE";
export type RequestRecurrenceEndCondition = "AFTER_OCCURRENCES" | "ON_DATE";
export type RequestRecurrenceType = "DAY" | "MONTH" | "WEEK";
export type RequestRestrictionType = "BLOCK" | "EVENT" | "RESTRICTION";
export type RoundType = "CUSTOMER" | "GUEST" | "MEMBER";
export type PreviewPatronRequestSeriesInput = {
  recurrence: PatronRequestRecurrenceInput;
  request?: RequestInput | null | undefined;
  sourceArgs?: PatronRequestPreviewSourceArgsInput | null | undefined;
  sourceBookingId: string;
};
export type PatronRequestRecurrenceInput = {
  endCondition: RequestRecurrenceEndCondition;
  endDate?: string | null | undefined;
  occurrenceCount?: number | null | undefined;
  recurrenceType: RequestRecurrenceType;
  repeatInterval: number;
};
export type RequestInput = {
  bookingRuleId?: string | null | undefined;
  id?: string | null | undefined;
  maxTime: string;
  minTime: string;
  requestCoursePreferences?: ReadonlyArray<RequestCoursePreferenceInput> | null | undefined;
  time: string;
};
export type RequestCoursePreferenceInput = {
  courseBucketId?: string | null | undefined;
  courseId?: string | null | undefined;
};
export type PatronRequestPreviewSourceArgsInput = {
  durationMins?: number | null | undefined;
  ownerMemberId?: string | null | undefined;
  rounds?: ReadonlyArray<PatronRequestPreviewRoundInput> | null | undefined;
  type?: BookingType | null | undefined;
};
export type PatronRequestPreviewRoundInput = {
  bookingIndex?: number | null | undefined;
  courseLayoutId?: string | null | undefined;
  hostId?: string | null | undefined;
  nonPlayingHost?: boolean | null | undefined;
  playerId?: string | null | undefined;
  rateId?: string | null | undefined;
  secondaryTransportationTypeId?: string | null | undefined;
  transportationTypeId?: string | null | undefined;
  type: RoundType;
};
export type ActionButtonsPreviewMutation$variables = {
  input: PreviewPatronRequestSeriesInput;
};
export type ActionButtonsPreviewMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly excluded: ReadonlyArray<{
      readonly conflict: {
        readonly endAt: string;
        readonly label: string;
        readonly startAt: string;
        readonly type: RequestRestrictionType;
      } | null | undefined;
      readonly date: string;
      readonly reason: RecurringRequestExclusionReason;
      readonly requestOpensDate: string | null | undefined;
    }> | null | undefined;
    readonly included: ReadonlyArray<{
      readonly date: string;
      readonly warnings: ReadonlyArray<{
        readonly endAt: string;
        readonly label: string;
        readonly startAt: string;
        readonly type: RequestRestrictionType;
      }> | null | undefined;
    }> | null | undefined;
    readonly proposedRemovals: ReadonlyArray<{
      readonly date: string;
    }> | null | undefined;
    readonly reviewedPlanToken: string | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type ActionButtonsPreviewMutation = {
  response: ActionButtonsPreviewMutation$data;
  variables: ActionButtonsPreviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reviewedPlanToken",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endAt",
    "storageKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "RecurringRequestOccurrence",
  "kind": "LinkedField",
  "name": "included",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RequestRestrictionStatus",
      "kind": "LinkedField",
      "name": "warnings",
      "plural": true,
      "selections": (v8/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "RecurringRequestExclusion",
  "kind": "LinkedField",
  "name": "excluded",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requestOpensDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RequestRestrictionStatus",
      "kind": "LinkedField",
      "name": "conflict",
      "plural": false,
      "selections": (v8/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "RecurringRequestOccurrence",
  "kind": "LinkedField",
  "name": "proposedRemovals",
  "plural": true,
  "selections": [
    (v7/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionButtonsPreviewMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "PreviewPatronRequestSeriesPayload",
        "kind": "LinkedField",
        "name": "previewPatronRequestSeries",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActionButtonsPreviewMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "PreviewPatronRequestSeriesPayload",
        "kind": "LinkedField",
        "name": "previewPatronRequestSeries",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "64d63b639b24c00bfe4dc4304a083267",
    "id": null,
    "metadata": {},
    "name": "ActionButtonsPreviewMutation",
    "operationKind": "mutation",
    "text": "mutation ActionButtonsPreviewMutation(\n  $input: PreviewPatronRequestSeriesInput!\n) {\n  responsePayload: previewPatronRequestSeries(input: $input) {\n    success\n    reviewedPlanToken\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n    included {\n      date\n      warnings {\n        type\n        label\n        startAt\n        endAt\n      }\n    }\n    excluded {\n      date\n      reason\n      requestOpensDate\n      conflict {\n        type\n        label\n        startAt\n        endAt\n      }\n    }\n    proposedRemovals {\n      date\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dc7c54a0951d415378b37d8fe89f2595";

export default node;
